import React, { Fragment, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { bindActionCreators, compose } from "redux";
import { connect } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import { setAuthInfo } from "../../module/auth/auth.action";
import { CONFIG } from "../../config/constant";
import "./index.scss";
import logo from "../../assets/images/logo.svg";



const ResetPassword = (props) => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [commonError, setCommonError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const params=useParams();
  const navigate = useNavigate();

  useEffect(() => {}, [])

  function isValidPassword() {
    if (!password) {
      setCommonError("Password required");
      return false;
    }
    return true;
  }

  function isValidConfirmPassword() {
    if (!confirmPassword) {
      setCommonError("Password required");
      return false;
    }
    if (password !==confirmPassword) {
      setCommonError("Confirm Password missmatch");
      return false;
    }
    return true;
  }

  async function ResetPassword() {
    if (!isValidPassword()) {
      return;
    }
    if (!isValidConfirmPassword()) {
      return;
    }
    if (password && confirmPassword) {
      const data = { password, token:params?.token };
      const url = CONFIG.BASE_URL + "auth/reset-password";
      let response = await fetch(url, {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
      if (response && response.status === 200) {
        let result = await response.json();
        setSuccessMessage(result.message);
        setTimeout(() => {
          navigate("/login");
        }, 3000);
      } else {
        response = await response.json();
        toast(response.message || response.error_message);
        setCommonError(response.message || response.error_message);
      }
    }
  }

  return (
    <Fragment>
      <div className="reset-page">
        <div className="content">
          <img src={logo} />
          <div className="content-section">
            <h2 className="title"> Reset Password</h2>
            <form
              onSubmit={() => {
                return;
              }}
            >
              <div className="input-wrapper">
                <label className="label">Password</label>
                <input
                  type='text'
                  placeholder="Password *"
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    setCommonError("");
                    setSuccessMessage("");
                  }}
                />
              </div>
              <div className="input-wrapper">
                <label className="label">Confirm Password</label>
                <input
                 type='text'
                  placeholder="Confirm Password *"
                  value={confirmPassword}
                  onChange={(e) => {
                    setConfirmPassword(e.target.value);
                    setCommonError("");
                  }}
                />
              </div>
              {successMessage?<div className="success-message">{successMessage}</div>:null}
              {commonError?<div className="common-error">{commonError}</div>:null}
              <input className="signup-btn" type="button" onClick={ResetPassword} value="Reset Password" />
            </form>
          </div>
        </div>
      </div>
      <ToastContainer />
    </Fragment>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      setAuthInfo,
    },
    dispatch
  );
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(ResetPassword);
